/**
 * Sort-field options for Phone tab server CSV export (Voluum metrics + dimensions).
 * For Media Devoted | Created By Ciro Autiero
 */

import { VOLUUM_COLUMNS } from '../../shared/constants';

export interface ServerExportSortOption {
  key: string;
  label: string;
}

/** Passed into CsvExportModal when server export supports choosing sort field/direction. */
export interface ServerCsvExportSortConfig {
  options: readonly ServerExportSortOption[];
  defaultSort: { field: string; dir: 'asc' | 'desc' } | null;
}

export function buildPhoneServerExportSortOptions(): ServerExportSortOption[] {
  return [
    { key: 'phone', label: 'Phone' },
    { key: 'sourceId', label: 'Source ID' },
    { key: 'country', label: 'Country (SMSWiser ID)' },
    { key: 'countryIso', label: 'Country ISO' },
    ...VOLUUM_COLUMNS.map((c) => ({ key: c.key, label: c.label })),
  ];
}
